import React from 'react';
import { Container, Title, Text, Paper, Stack } from '@mantine/core';

export function AdminPage() {
  return (
    <Container size="lg" py="xl" pb={80} sx={{ minHeight: 'calc(100vh - 140px)' }}>
      <Paper shadow="md" p="xl" radius="md">
        <Stack spacing="lg">
          <Title order={2}>Admin Dashboard</Title>
          <Text>
            This is the administration area. Here you can manage users, reports, and system settings.
          </Text>
          {/* Admin functionality will go here */}
        </Stack>
      </Paper>
    </Container>
  );
} 